import React, { useEffect, useMemo, useState } from 'react';

import { calculateRowTotals } from '../../utils/calculations';
import { getIndentClass } from '../../utils/styleUtils';

import ContractRow from './ContractRow';
import SponsorMilestoneData from './SponsorMilestoneData';

import { formatFigure } from 'Helpers/formatService';

import ChevronDownIcon from 'Assets/icons/chevron-down.svg';
import ChevronUpIcon from 'Assets/icons/chevron-up.svg';

export default function CommittedSection(props) {
    const [showCommittedChildren, setShowCommittedChildren] = useState(false);

    // Handle expand all trigger from parent with staggered updates
    useEffect(() => {
        const t = props.expandAllTrigger;
        if (!t?.version) return;

        if (t.batch === 'committed' || t.batch === 'projects committed') {
            setShowCommittedChildren(t.expanded);
        }
    }, [props.expandAllTrigger?.version]);

    // Calculate indentation level
    const indentLevel = props.indentLevel || 3;
    const childIndentLevel = indentLevel + 1;

    const toggleCommittedShow = () => {
        setShowCommittedChildren(!showCommittedChildren);
    };

    const committed = props.sponsor.committed;
    if (!committed || Object.keys(committed).length === 0) return null;

    // Calculate total committed value and aggregate currentMilestones
    const contracts = Object.values(committed);
    const totalCommittedValue = contracts.reduce((sum, contract) => sum + contract.value, 0);

    // Aggregate currentMilestones from all contracts
    const aggregatedCurrentMilestones = [];
    const { maxSponsorMilestonesCount } = props;

    for (let i = 0; i < maxSponsorMilestonesCount; i++) {
        let totalAmount = 0;
        let milestoneDate = null;

        contracts.forEach((contract) => {
            if (contract.currentMilestones && contract.currentMilestones[i]) {
                totalAmount += contract.currentMilestones[i].amount || 0;
                if (!milestoneDate) {
                    milestoneDate = contract.currentMilestones[i].date;
                }
            }
        });

        aggregatedCurrentMilestones.push({
            amount: totalAmount,
            date: milestoneDate || '',
        });
    }

    const totalValue = useMemo(() => {
        let totalAmount = 0;
        Object.entries(committed).map(([contractRef, contract]) => {
            totalAmount += calculateRowTotals(contract.currentMilestones).totalValue;
        });

        return totalAmount;
    }, [committed]);

    return (
        <>
            <tr className="!tw-bg-gray-50">
                <td>
                    <div className={`tw-flex tw-items-center tw-gap-x-1.5 tw-cursor-pointer ${getIndentClass(indentLevel)}`} onClick={toggleCommittedShow}>
                        <div className="tw-font-medium tw-text-gray-700">{$t('Committed')}</div>
                        <div>{showCommittedChildren ? <ChevronUpIcon /> : <ChevronDownIcon />}</div>
                    </div>
                </td>
                <td className="tw-p-4"></td>
                <td className="tw-p-4 tw-text-right tw-text-gray-700 tw-border-r-2">{formatFigure(totalValue)}</td>
                {[...Array(maxSponsorMilestonesCount)].map((e, i) => {
                    return (
                        <React.Fragment key={`committed_milestones_${i}`}>
                            <SponsorMilestoneData
                                key={`${props.keyPrefix || ''}committed_${props.sponsor.id}_milestone_${i}`}
                                milestones={aggregatedCurrentMilestones}
                                milestoneId={i}
                                keyPrefix={props.keyPrefix || ''}
                                amountOnly={true}
                            />
                        </React.Fragment>
                    );
                })}
                <td className="tw-p-4 tw-text-right tw-border-r-2"></td>
                <td className="tw-p-4 tw-text-right tw-border-r-2">{formatFigure(totalValue)}</td>
                <td className="tw-p-4 tw-text-right tw-border-r-2"></td>
            </tr>
            {showCommittedChildren && (
                <>
                    {Object.entries(committed).map(([contractRef, contract]) => (
                        <ContractRow
                            {...props}
                            key={`contract_${contractRef}_${props.sponsor.id}`}
                            contract={contract}
                            periods={props.periods}
                            sponsor={props.sponsor}
                            indentLevel={childIndentLevel}
                        />
                    ))}
                </>
            )}
        </>
    );
}
